import { IconChevronDown, StatusLabel } from '@snsw/react-component-library';
import { GelTheme } from 'components/GelTheme';
import { SummaryCardProps } from 'components/SummaryCard/SummaryCard';
import React from 'react';
import styled, { css } from 'styled-components/macro';

interface SummaryCardTitleProps extends Pick<SummaryCardProps, 'status' | 'disableCollapse'> {
  contentId?: string;
  collapsed: boolean;
  onToggleCollapsed: () => void;
}

const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

const StatusContainer = styled.div`
  flex: 1 1 ${GelTheme.spacing(2)};
`;

const Chevron = styled.div<{ collapsed?: boolean }>`
  flex: 0 0 ${GelTheme.spacing(1)};

  svg {
    cursor: pointer;
    transition: transform 200ms ease-out;
  }

  ${(props) =>
    !props.collapsed &&
    css`
      svg {
        transform: rotate(-180deg);
      }
    `}
`;

export const SummaryCardStatusRow = ({
  status,
  collapsed,
  onToggleCollapsed,
  disableCollapse,
  contentId,
}: SummaryCardTitleProps) => {
  const hasTitle = !!(status?.text || !disableCollapse);
  if (!hasTitle) return null;

  return (
    <StatusRow>
      <StatusContainer>{status && <StatusLabel text={status.text} variant={status.variant} />}</StatusContainer>

      {!disableCollapse && (
        <Chevron collapsed={collapsed}>
          <IconChevronDown
            aria-label="Toggle content"
            aria-expanded={!collapsed}
            aria-controls={contentId}
            onClick={onToggleCollapsed}
          />
        </Chevron>
      )}
    </StatusRow>
  );
};
